var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Key-Line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aviso-de-Privacidad",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AdP_Web",
    transform: "translate(-311.000000, -272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Key-Line",
    transform: "translate(311.000000, 272.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 50.4,
    height: 50.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.298,26.082 C28.0962609,26.0517922 24.4992165,23.0616988 23.7017242,18.9362255 C22.9042318,14.8107522 25.127745,10.6954908 29.0155125,9.10150613 C32.9032801,7.50752143 37.3757182,8.8774428 39.7038187,12.3753667 C42.0319191,15.8732907 41.569198,20.527888 38.598,23.499 C36.9283937,25.168558 34.6590847,26.0989747 32.298,26.082 L32.298,26.082 Z M32.298,10.542 C30.514034,10.5363988 28.8015193,11.242598 27.5400587,12.5040587 C26.278598,13.7655193 25.5723988,15.478034 25.5779216,17.262 C25.5693233,19.0454181 26.2811299,20.7567828 27.552,22.008 C29.7118365,24.1349495 33.0282692,24.552591 35.6480057,23.0275375 C38.2677423,21.5024841 39.5421481,18.412332 38.7590584,15.4839232 C37.9759686,12.5555144 35.3292727,10.5139094 32.298,10.5 L32.298,10.542 Z",
    id: "Shape",
    fill: "#1D1D1B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.125,16.569 L32.991,15.456 C32.6138832,15.0795064 32.0031168,15.0795064 31.626,15.456 L30.492,16.569 C30.1155064,16.9461168 30.1155064,17.5568832 30.492,17.934 L31.626,19.068 C32.0031168,19.4444936 32.6138832,19.4444936 32.991,19.068 L34.125,17.934 C34.5014936,17.5568832 34.5014936,16.9461168 34.125,16.569 Z",
    id: "Path",
    fill: "#1D1D1B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.84,40.383 C21.6655143,40.5661574 21.4207848,40.6655788 21.168,40.656 C20.9097941,40.6612955 20.6602193,40.5629781 20.475,40.383 L15.519,35.427 L13.125,37.8 C12.952683,37.9886602 12.7085066,38.0954874 12.453,38.094 C12.1912515,38.0962073 11.9403127,37.9897484 11.76,37.8 C11.5887676,37.6176352 11.4914625,37.378115 11.487,37.128 C11.4882702,36.8710143 11.5856557,36.623805 11.76,36.435 L25.956,22.239 C26.1379059,22.0516838 26.3878925,21.9459837 26.649,21.9459837 C26.9101075,21.9459837 27.1600941,22.0516838 27.342,22.239 C27.5168349,22.4190347 27.6147443,22.6600425 27.615,22.911 C27.6137298,23.1679857 27.5163443,23.415195 27.342,23.604 L19.95,30.975 L24.927,35.931 C25.236106,36.3238518 25.2027052,36.8857694 24.8492373,37.2392373 C24.4957694,37.5927052 23.9338518,37.626106 23.541,37.317 L18.585,32.34 L16.8,34.041 L21.756,39.018 C21.8556594,39.0998782 21.9287507,39.2095151 21.966,39.333 C21.9971775,39.4499579 21.9971775,39.5730421 21.966,39.69 C21.9954747,39.8142763 21.9954747,39.9437237 21.966,40.068 C21.9525792,40.1822909 21.9091028,40.2909819 21.84,40.383 Z",
    id: "Path",
    fill: "#1D1D1B",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyLine);
export default __webpack_public_path__ + "static/media/Key-Line.4ca01afef27588923f5afae29e7540f6.svg";
export { ForwardRef as ReactComponent };